import "./multipleChoice.scss";

import { useState } from "react";
import { OptionModel } from "../../../models/questionModel";
import MultipleChoiceOption from "../../../../../common/components/inputFields/multipleChoiceOption/multipleChoiceOption";

export default function MultipleChoice(props: {
  optionsData?: OptionModel[];
  onChange?: (e: OptionModel[]) => void;
}) {
  const [options, setOptions] = useState<OptionModel[]>(
    props.optionsData ?? []
  );

  return (
    <div className="multiple-choice">
      {options.map((e, i) => (
        <MultipleChoiceOption
          key={i}
          initialValue={e}
          onChange={(e) => {
            let temp = [...options];
            temp[i] = e;
            setOptions(temp);
            props.onChange?.(temp);
          }}
          onClickDelete={() => {
            let temp = [...options];
            temp = temp.filter((e2) => e2 != e);
            setOptions(temp);
            props.onChange?.(temp);
          }}
          isFocused={options.length - 1 == i}
          maxWidth="300px"
        />
      ))}
      <MultipleChoiceOption
        value=""
        isEditable={false}
        placeholder="Add option"
        onChange={(e) => {
          setOptions([...options, { ...e, score: 0 }]);
          props.onChange?.([...options, { ...e, score: 0 }]);
        }}
        maxWidth="300px"
      />
    </div>
  );
}
